import {
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormInputCheckboxComponent } from '@libs/ui';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import {
  isForecastSeriesFetchingOrPending,
  selectFixedYAxisZeroPoint,
} from 'demand-forecasting/store/forecast-series/forecast-series.selectors';

@Component({
  selector: 'pm-fixed-y-axis-zero-point',
  templateUrl: './fixed-y-axis-zero-point.component.html',
  imports: [
    FormInputCheckboxComponent,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
  ],
})
export class FixedYAxisZeroPointComponent {
  private readonly store = inject(Store);

  @Input() fixedYAxisZeroPoint = true;
  @Output() fixedYAxisZeroPointChange = new EventEmitter<boolean>();

  protected isLoading = this.store.selectSignal(
    isForecastSeriesFetchingOrPending,
  );

  selectFixedYAxisZeroPointSignal = this.store.selectSignal(
    selectFixedYAxisZeroPoint,
  );

  constructor() {
    effect(() => {
      const singalValue = this.selectFixedYAxisZeroPointSignal();
      this.fixedYAxisZeroPoint = !!(
        singalValue === undefined || singalValue === true
      );
      this.fixedYAxisZeroPointChange.emit(this.fixedYAxisZeroPoint);
    });
  }

  onFixedYAxisZeroPointChange(): void {
    this.fixedYAxisZeroPointChange.emit(this.fixedYAxisZeroPoint);
  }
}
